import { render, staticRenderFns } from "./DatingTab.vue?vue&type=template&id=0b3489d9&scoped=true"
import script from "./DatingTab.vue?vue&type=script&lang=js"
export * from "./DatingTab.vue?vue&type=script&lang=js"
import style0 from "./DatingTab.vue?vue&type=style&index=0&id=0b3489d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3489d9",
  null
  
)

export default component.exports